module.exports = __webpack_public_path__ + "img/kategoria_digitalmarketing.770eb70c.jpg";